import React from "react";

const TABLE_COLUMNS = [
  { key: "date", label: "Date", render: (value) => ({ className: "text-gray-600 dark:text-gray-400", content: value }) },
  { key: "totalAmount", label: "Total", render: (value) => ({ className: "font-semibold text-gray-900 dark:text-white", content: `₹${typeof value === 'number' ? value.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : value?.toLocaleString('en-IN')}` }) },
];

export const TableHeader = () => (
  <thead>
    <tr className="bg-gray-50 dark:bg-gray-900/40 border-b border-gray-200 dark:border-gray-700">
      {TABLE_COLUMNS.map((column) => (
        <th
          key={column.key}
          className="px-6 py-4 font-semibold text-gray-700 dark:text-gray-300 text-xs uppercase tracking-wider"
        >
          {column.label}
        </th>
      ))}
      <th className="px-6 py-4 font-semibold text-gray-700 dark:text-gray-300 text-xs uppercase tracking-wider text-right">
        Action
      </th>
    </tr>
  </thead>
);

export { TABLE_COLUMNS };
